import * as React from "react";
const SvgDot = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 5 5", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 2.64648, cy: 2.55469, r: 2, fill: "currentColor" }));
export default SvgDot;
